import type PageModel from 'admin-panel/models/page';

export function isPageInFolder(
  page: PageModel,
  categoryId: string,
  hotelId: string
) {
  if (page.belongsTo('category').id() !== categoryId) {
    return false;
  }

  const pageHotelId = page.belongsTo('hotel').id();

  return !pageHotelId || pageHotelId === hotelId;
}
